interface IErrorContents {
  code: string
  message?: string
}

class CustomError extends Error {
  code: string

  constructor(contents: IErrorContents) {
    super(contents.message)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError)
    }

    this.code = contents.code
  }
}

export function createError(contents: IErrorContents) {
  return new CustomError(contents)
}
